import { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { Panes } from 'modules/core/components/Panes'
import renderIfFeature from 'modules/core/lib/renderIfFeature'

import Schema from 'modules/custom_resources/store/models/customResources/Schema'
import Appearance from 'modules/settings/components/Appearance'
import GenderSettings from 'modules/settings/components/GenderSettings'
import { WorkspaceLogoUploadPane } from 'modules/settings/components/WorkspaceLogoUploadPane'

import { CustomFields } from './CustomFields'
import { CustomResources } from './CustomResources'
import PayrollSettings from './PayrollSettingsForm'

interface Props {
  canManageTables: boolean
}

const CustomizationSettings: FC<Props> = ({ canManageTables }) => {
  const topicNames = [Schema.TOPIC_NAMES.employees, Schema.TOPIC_NAMES.performance]
  return (
    <Panes direction="vertical">
      <WorkspaceLogoUploadPane />
      <Appearance />
      {renderIfFeature('payroll')(() => (
        <PayrollSettings />
      ))}
      <GenderSettings />
      <Box paddingX="s64">
        <CustomFields />
      </Box>
      <CustomResources
        canManageTables={canManageTables}
        topicNames={topicNames}
        createTopicName={Schema.TOPIC_NAMES.employees}
      />
    </Panes>
  )
}

export default CustomizationSettings
